import Loading from 'components/dashboard/charts/Loading';
import Layout from 'components/dashboard/Layout';
import { useRequireAuth } from 'hooks/useRequireAuth';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { getRecentTestRunSummaries } from 'services/testRun';

const getTestScenarioId = (query): string => {
  return query.slug;
};

const LatestRunPage = () => {
  const { user } = useRequireAuth();
  const router = useRouter();
  const testScenarioId = getTestScenarioId(router.query);

  useEffect(() => {
    if (user?.readToken) {
      getRecentTestRunSummaries(user.readToken, 1, 0, testScenarioId)
        .then((testRunSummaries) => {
          if (testRunSummaries.length > 0) {
            router.push(`/test-runs/${testRunSummaries[0].runId}`);
          } else {
            router.push(`/test-runs/unknown`);
          }
        })
        .catch((err) => console.error('Error fetching latest test run', err));
    }
  }, [user?.readToken, router, testScenarioId]);

  if (!user) return null;

  return (
    <>
      <Layout>
        <Loading />
      </Layout>
    </>
  );
};

export default LatestRunPage;
